import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl } from '@angular/forms';

@Directive({
  selector: '[appScenarioItemValidator][ngModel]',
  standalone: true,
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: ScenarioItemValidatorDirective,
    multi: true
  }]
})
export class ScenarioItemValidatorDirective {
  @Input() scenarioValueErrors?: Record<string, Record<string, boolean>>;
  @Input() uuid: string;

  validate(control: UntypedFormControl) {
    let isValid = true;

    if (control.errors) {
      return {invalid: true};
    }

    if (this.scenarioValueErrors[this.uuid] && Object.keys(this.scenarioValueErrors[this.uuid])?.length > 0) {
      isValid = false;
    }

    return isValid ? null : {invalid: !isValid};
  }
}
